import React, { memo, useState } from 'react';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';
import Select from 'corp/components/UI/Select';
import {
  AutoCompleteFieldInputProps,
  DynamicFieldWithForMetadata,
} from '@scale/shared/corp/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { makeStyles } from 'react-scale/components/design-system/styles';

const useStyles = makeStyles({
  container: {
    border: 'solid lightgray',
    borderRadius: '6px',
  },
  listElement: {
    padding: 5,
  },
  listElementText: {
    padding: 8,
  },
});

interface AutoCompleteFieldProps extends AutoCompleteFieldInputProps {
  onChange: (newValue: any) => void;
  value: any;
}

const AutoCompleteField = ({
  apiFetchEndpoint,
  showFieldId,
  placeholder,
  transformResult,
  onChange,
  value,
  multiple,
}: AutoCompleteFieldProps) => {
  const classes = useStyles();
  const [currentVal, setCurrentVal] = useState(undefined);
  const handleTrashClick = (toRemove: { value: string }) => {
    onChange(value.filter((val: { value: string }) => val.value !== toRemove.value));
  };
  const valueList = value ?? [];
  const handleAdd = (toAdd: { value: string; label: string }) => {
    if (!!toAdd && !valueList.some((val: { value: string }) => val.value === toAdd.value))
      onChange([...valueList, toAdd]);
    setCurrentVal(undefined);
  };
  async function fetchFields(search: string) {
    try {
      const response =
        (await apiFetch(null, apiFetchEndpoint, {
          method: 'GET',
          query: { search },
        })) ?? [];
      const results = transformResult ? transformResult(response) : response;
      const options = results.map((oneField: DynamicFieldWithForMetadata) => ({
        label: showFieldId ? `${oneField.label} (${oneField.id})` : oneField.label,
        value: oneField.id,
        forMetadata: oneField.forMetadata,
      }));
      return {
        options,
      };
    } catch (error) {
      defaultApiFetchErrorHandler(error, { handleHttp: true });
      return [];
    }
  }
  if (multiple) {
    const multiples = valueList.map((val: { value: string; label: string }) => (
      <div className={classes.listElement} key={val.value}>
        <FontAwesomeIcon onClick={() => handleTrashClick(val)} icon="trash" />
        <span className={classes.listElementText}>{val.label}</span>
      </div>
    ));
    return (
      <div className={classes.container}>
        <Select
          value={currentVal}
          onChange={handleAdd}
          loadOptions={fetchFields}
          ignoreCase={true}
          placeholder={placeholder ?? 'Write a name or id'}
        />
        {multiples}
      </div>
    );
  }

  return (
    <div>
      <Select
        value={value}
        onChange={onChange}
        loadOptions={fetchFields}
        ignoreCase={true}
        placeholder={placeholder ?? 'Write a name or id'}
      />
    </div>
  );
};

export default memo(AutoCompleteField);
